import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import VerReclamo from '../../AppComponentsNUtils/ModalVerReclamo';
import GetReclamo from '../../AppComponentsNUtils/GetReclamo';
import AddRecurso from '../../AppComponentsNUtils/AddRecurso';
import AddAntecedente from '../../AppComponentsNUtils/AddAntecedente';
import { validacionPermit } from '../../../../../services/service.user';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import Spinner from '@jumbo/components/custom/Spinner';
import {
  getDatosEntidadesList,
  tableHeadCellsDerivaciones,
  validaciones,
  derivacionesActions,
  tableHeadCellsIsRedDerivaciones,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';
import ModalProrroga from '../../AppComponentsNUtils/ModalProrroga';
import RenderFile from 'customComponents/RenderFile';
import { getDataDerivaciones, getDataDerivacionesIpXpage, getDataDerivacionesNetwork, getNetworkMembers } from 'services/api';

const TablaReclamosPendientes = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showAutoAsignarReclamo, setShowAutoAsignarReclamo] = useState(false);
  const [reclamoAutoAsignar, setReclamoAutoAsignar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);
  const [showAddRec, setShowAddRec] = useState(false);
  const [reclamoAddRec, setrReclamoAddRec] = useState(null);

  const [showProrroga, setShowProrroga] = useState(false);
  const [reclamoProrroga, setReclamoProrroga] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewSuper, setShowPreviewSuper] = useState(false);
  const [url, setUrl] = useState(undefined);
  const [urlSuper, setUrlSuper] = useState(undefined);

  const [reload, setReload] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'));

  const loadEntidades = () => {
    loadData();
  };

  const loadData = async () => {

    if (user.is_network) {
      if (user.organization.network_id) {
        getNetworkMembers(user.organization.network_id)
          .then(resNet => {

            const entidadesQueryString = resNet.data.members
              .map(item => `entidades=${item.name}`)
              .join('&')

            getDataDerivacionesNetwork(entidadesQueryString)
              .then(res => {
                let auxItem = [];
                res.data.map((item, index) => {
                  if (item.is_copiarec_upload) {
                    let aux2 = getDatosEntidadesList(item);
                    auxItem.push(aux2);
                  }
                  return null;
                });
                setEntidadesList(auxItem);
                setPrimeraCarga(true);
              })
              .catch(err => {
                toast.error('Ocurrió un error al buscar reclamos pendientes.');
                console.log(err);
              })
              .finally(e => {
                setSpinner(false);
              });

          })
          .catch(error => {
            toast.error('Ocurrió un error al buscar los datos de la red.');
            console.error(error)
          })
          .finally(fin => {

          })
      } else {
        toast.error("El usuario está configurado como un usuario de red, por favor contactar con administrador.")
        setPrimeraCarga(true)
        setSpinner(false)
      }

    } else {
      getDataDerivaciones()
        .then(res => {
          let auxItem = [];
          res.data.map((item, index) => {
            if (item.is_copiarec_upload) {
              let aux2 = getDatosEntidadesList(item);
              auxItem.push(aux2);
            }
            return null;
          });
          setEntidadesList(auxItem);
          setPrimeraCarga(true);
        })
        .catch(err => {
          toast.error('Ocurrió un error al buscar reclamos pendientes.');
          console.log(err);
        })
        .finally(e => {
          setSpinner(false);
        });
    }


  };

  useEffect(() => {
    loadEntidades();
    // eslint-disable-next-line
  }, [reload]);

  /*  const loadData = () => {
      //setSpinner(true);
      const nombrePrestador = JSON.parse(sessionStorage.getItem('user')).organization.name;
      const queryString = `?nombre_prestador=${encodeURIComponent(nombrePrestador)}`;
    
      getDataDerivacionesIpXpage(queryString)
        .then(res => {
          setEntidadesList(
            res.data.data.map((entidad) => getDatosEntidadesList(entidad, true))
          );
          setPrimeraCarga(true);
        })
        .catch(err => {
          toast.error('Ocurrió un error al cargar reclamos gestionados desde XPage');
          console.error(err);
        })
        .finally(() => {
          setSpinner(false);
        });
    };  */



  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    } else if (menu.action === 'addRec') {
      setrReclamoAddRec(item);
      setShowAddRec(true);
    } else if (menu.action === 'autoAsignar') {
      setReclamoAutoAsignar(item);
      setShowAutoAsignarReclamo(true);
    } else if (menu.action === 'prorroga') {
      setReclamoProrroga(item);
      setShowProrroga(true);
    }
  };

  const openModal = fila => {
    setReclamoVer(fila);
    setShowVerReclamo(true);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  const AddRecClose = () => {
    setrReclamoAddRec(null);
    setShowAddRec(false);
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const autoAsignarReclamoClose = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
  };

  const autoAsignarReclamoSubmit = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
    setSpinner(true);
    //loadEntidades();
    setReload(!reload);
  };

  const closeModalProrroga = () => {
    setShowProrroga(false);
    setReclamoProrroga(null);
  };

  const closePreview = () => {
    setShowPreview(false);
    setUrl('');
  };

  const cargarUrl = url => {
    setUrl(url);
    setShowPreview(true);
  };

  const closePreviewSuper = () => {
    setShowPreviewSuper(false);
    setUrlSuper('');
  };
  const cargarUrlSuper = url => {
    setUrlSuper(url);
    setShowPreviewSuper(true);
  };

  return (
    validacionPermit('search_reclaim_ip') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo
          openDialog={showVerReclamo}
          close={verReclamoClose}
          reclamo={reclamoVer}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
        />
        <AddAntecedente
          openDialog={showAddAnt}
          close={AddAntClose}
          reclamo={reclamoAddAnt}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
          setReload={setReload}
          reload={reload}
        />
        {showPreview ? <RenderFile openDialog={showPreview} url={url} close={closePreview} /> : null}
        {showPreviewSuper ? <RenderFile openDialog={showPreviewSuper} url={urlSuper} close={closePreviewSuper} /> : null}
        <AddRecurso openDialog={showAddRec} close={AddRecClose} reclamo={reclamoAddRec} />
        <ModalProrroga
          openDialog={showProrroga}
          close={closeModalProrroga}
          reclamo={reclamoProrroga}
          reload={reload}
          setReload={setReload}
        />
        <GetReclamo
          openDialog={showAutoAsignarReclamo}
          close={autoAsignarReclamoClose}
          reclamo={reclamoAutoAsignar}
          submit={autoAsignarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1>No hay reclamos pendientes</h1>
          ) : (
            <CustomTable
              headCells={user.is_network ? tableHeadCellsIsRedDerivaciones : tableHeadCellsDerivaciones}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={derivacionesActions}
              handleAction={handleAction}
              openModal={openModal}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosPendientes;
